"use client";

import React from "react";
import { Linkedin, Globe, Mail, ArrowRight, Loader } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
import { Link } from "@/components/common/Link";
const socialLinks = [{
  name: "LinkedIn Profile",
  icon: Linkedin,
  url: "https://www.linkedin.com",
  description: "www.linkedin.com/in/nathan-harrington-8a4621228"
}, {
  name: "Instagram",
  icon: Globe,
  url: "https://www.loyola.edu",
  description: "@nate.harrington_"
}, {
  name: "Direct Contact",
  icon: Mail,
  url: "mailto:nathan.harrington@loyola.edu",
  description: "nathan.andrew.harrington@gmail.com\n(810) 441-6290"
}];
function InquiryForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex items-center justify-center p-4 bg-primary/10 border border-primary/20 rounded-lg backdrop-blur-sm">
        <p className="text-primary-foreground font-medium text-center">
          {successMessage}
        </p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-0 relative">
      <FormField control={control} name="email" rules={{
      required: "Email is required for updates.",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Please enter a valid email address."
      }
    }} render={({
      field
    }) => <FormItem className="w-full">
            <div className="relative flex items-center w-full">
              <FormControl>
                <input type="email" placeholder="Enter your email for consulting insights..." className="flex h-14 w-full rounded-full border border-border/50 bg-background/40 px-6 py-2 text-base text-foreground ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 backdrop-blur-md transition-all pr-36" {...field} />
              </FormControl>
              <Button type="submit" disabled={isSubmitting} className="absolute right-1.5 h-11 rounded-full px-6 bg-primary hover:bg-primary/90 text-primary-foreground transition-colors">
                {isSubmitting ? <Loader className="animate-spin size-4" /> : <>
                    Connect
                    <ArrowRight className="ml-2 size-4" />
                  </>}
              </Button>
            </div>
            <div className="absolute -bottom-6 left-4">
              <FormMessage className="text-destructive-foreground bg-destructive/90 px-2 py-0.5 rounded text-xs" />
            </div>
          </FormItem>} />
      {submitError && <div className="absolute -bottom-12 left-0 w-full p-2 bg-destructive/20 border border-destructive/50 rounded text-center">
          <p className="text-destructive-foreground text-sm">{submitError}</p>
        </div>}
    </Form>;
}
export default function SocialMediaLinks() {
  return <section id="social-media-links" className="dark bg-background text-foreground relative py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600191/img/chicago_financial_district_dusk.png)] bg-cover bg-center bg-no-repeat opacity-40 mix-blend-luminosity" />
        <div className="absolute inset-0 bg-gradient-to-b from-background/95 via-background/80 to-background/95 backdrop-blur-[2px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10 flex flex-col items-center">
        {}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold tracking-tight mb-6 text-foreground">I look forward to connecting with you.</h2>
          
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full max-w-5xl mb-20">
          {socialLinks.map((link, i) => {
          const Icon = link.icon;
          return <div data-index={i} key={i} className="w-full">
                <Button asChild variant="outline" className="w-full h-auto py-6 px-6 flex flex-col items-center justify-center gap-3 rounded-2xl border-border/30 bg-card/30 backdrop-blur-sm hover:bg-primary/20 hover:border-primary/50 transition-all duration-500 group">
                  <Link to={link.url} newTab={link.url.startsWith("http")}>
                    <div className="p-4 rounded-full bg-background/50 group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-500 mb-2">
                      <Icon className="size-8" />
                    </div>
                    <div className="text-center space-y-1">
                      <span className="block text-lg font-semibold text-foreground group-hover:text-primary-foreground transition-colors">
                        {link.name}
                      </span>
                      <span className="block text-sm text-muted-foreground group-hover:text-primary-foreground/80 transition-colors !w-[500px]">
                        {link.description}
                      </span>
                    </div>
                  </Link>
                </Button>
              </div>;
        })}
        </div>

        {}
        <div className="w-full max-w-2xl mx-auto text-center">
          <div className="mb-8">
            
            
          </div>

          <FormProvider formId="visionary-cta-form" sectionName="SocialMediaLinks" defaultValues={{
          email: ""
        }} submitText="Connect" successMessage="Thank you for connecting. I will be in touch soon.">
            <InquiryForm />
          </FormProvider>
        </div>
      </div>
    </section>;
}